import React from 'react';
import IconField from 'components/Form/Fields/IconField';

export default function DateField(props) {
    return <IconField {...props} prepend={'calendar'} type={'date'} />;
}
